import CONFIG from "config/config";
import LogRocket from "logrocket";
import { REGEX_FOR_CAMPAIGN_NAME } from "../constants";
import { getFilteredCities } from "./filters";
import { NAVIGATION, CHANNEL_NAVIGATION } from "../pages/constants";

export function getCurrencyCode(country) {
  switch (country.currencySign) {
    case "$":
      if (country.name === "Canada") {
        return "CAD";
      } else if (country.name === "Australia") {
        return "AUD";
      } else if (country.name === "New Zealand") {
        return "NZD";
      } else {
        return "USD";
      }
    case "€":
      return "EUR";
    case "£":
      return "GBP";
    case "CHF":
      return "CHF";

    default:
      return "USD";
  }
}

export const sortAscCitiesList = (citiesList) =>
  citiesList.sort((a, b) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  });

export const getCitiesList = async ({ channel, country }) => {
  const cities = await getFilteredCities({
    country,
    channel,
  });

  return sortAscCitiesList(cities);
};

export const getLogRocketSessionURL = ({ short = false }) => {
  let logRocketURL = "";
  LogRocket.getSessionURL((sessionURL) => (logRocketURL = sessionURL.split("?")[0]));
  if (short) {
    logRocketURL = logRocketURL.split("oppizi")[1];
  }
  return logRocketURL;
};

export const gtagWrapper = ({ event, ...params } = {}) => {
  try {
    if (window.dataLayer && event) {
      //console.log(event, params);
      window.dataLayer.push({
        event,
        params,
      });
    }
  } catch (error) {
    console.error("ERROR_gtag", error);
  }
};

export const isProduction = () => CONFIG.ENV === "production";
const specialCharacter = "#";
/**
 * seperate by special character like '#': we can change this character
 */
export const convertStringSeperatedBySpecialToArray = (str) => (str ? str.split(specialCharacter) : []);

export const convertArrayToStringSeperatedBySpecial = (arr) => (arr ? arr.join(specialCharacter) : "");

export const createMinimumMissionLimitError = ({ acc = {}, isD2D, missionLimit }) => {
  return {
    ...acc,
    title: `Not enough ${isD2D ? "areas" : "distributors"}!`,
    message: acc.message
      ? acc.message.split("to continue.").join(`and ${missionLimit} ${isD2D ? "areas" : "distributors"} to continue.`)
      : `Please, select at least ${missionLimit} ${isD2D ? "areas" : "distributors"} to continue.`,
  };
};

export const checkIsNeedUpdateLastActiveStepState = ({ stateLastActiveStep, newLastActiveStep, channel }) => {
  const navigation = channel && CHANNEL_NAVIGATION[channel] ? CHANNEL_NAVIGATION[channel] : NAVIGATION;
  if (stateLastActiveStep === "home") {
    return true;
  } else {
    const stateStep = navigation.find((item) => item.step === stateLastActiveStep);
    const newStep = navigation.find((item) => item.step === newLastActiveStep);

    return stateStep && newStep && stateStep.index < newStep.index;
  }
};

export const formatCampaignName = (name) => {
  const cleanName = name.replace(REGEX_FOR_CAMPAIGN_NAME, "");
  if (cleanName.length > 32) {
    return cleanName.slice(0, 32);
  } else {
    return cleanName;
  }
};

export const validateCampaignName = (campaignName) => {
  if (!campaignName) {
    return null;
  }
  const trimmedCampaignName = campaignName.trim();
  const noSpaceCampaignName = campaignName.replace(/\s/g, "");

  if (!trimmedCampaignName.length) {
    return "Latin characters required";
  }

  if (noSpaceCampaignName.length < 4) {
    return "Campaign name is too short (minimum 4 characters)";
  }

  if (trimmedCampaignName.length > 32) {
    return "Campaign name is too long (maximum 32 characters)";
  }

  const isLangError = REGEX_FOR_CAMPAIGN_NAME.test(campaignName);

  if (isLangError) {
    return "Campaign name contains invalid characters.";
  }

  return null;
};

/* Hide part of the email for security reasons */
export const hideEmail = (email) => {
  if (typeof email !== "string" || !email.includes("@")) return "";
  const atIndex = email.lastIndexOf("@");
  const name = email.slice(0, atIndex);
  const domain = email.slice(atIndex + 1);
  // Show at most 4 chars and at most half the local part, always mask with at least 2 asterisks
  const visibleChars = Math.min(4, Math.max(1, Math.floor(name.length / 2)));
  const hiddenName = name.slice(0, visibleChars) + "*".repeat(Math.max(name.length - visibleChars, 2));
  return `${hiddenName}@${domain}`;
};

export const getMobileEmailBody = (name) => {
  return `<div stlye="width: 100%;">
            <p style="color: #00112B; font-size: 14px; padding-bottom: 10px;">Hi ${name},</p>
            <p style="color: #00112B; font-size: 14px; padding-bottom: 10px;">We noticed that you started creating a campaign on mobile.</p>
            <p style="color: #00112B; font-size: 14px; padding-bottom: 10px;">To continue designing your Oppizi campaign seamlessly, access our Campaign Creation Tool on desktop by clicking here: </p>
            <table style="margin: 20px auto;">
              <tbody>
                <tr>
                  <td>
                    <a href="https://app.oppizi.com" 
                      style="text-decoration: none;
                              color: #FFFFFF !important;
                              background-color: #F42156;
                              padding: 10px 20px;
                              line-height: 2em;
                              font-weight: bold;
                              text-align: center;
                              cursor: pointer;
                              display: inline-block;
                              font-size: 14px;
                              border-radius: 16px;"
                      >
                      Continue to create campaign   
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <p style="color: #526181; font-size: 12px; ">If you are having trouble clicking the button, copy and paste this URL into your web browser</p> 
            <a href="https://app.oppizi.com" style="color: #F42156 !important;">https://app.oppizi.com</a>
          </div>`;
};
